import React from 'react';

const SmallScreenNavigationSideMenuContext = React.createContext<{
  isSidebarOpen: boolean;
  toggleSidebar: (isOpen?: boolean) => void;
}>({
  isSidebarOpen: false,
  toggleSidebar: () => {},
});

export const SmallScreenNavigationSideMenuProvider = (props: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const toggleSidebar = React.useCallback((isOpen?: boolean) => {
    if (isOpen === undefined) {
      setIsOpen((prev) => !prev);
      return;
    }

    setIsOpen(isOpen);
  }, []);

  const value = React.useMemo(
    () => ({
      isSidebarOpen: isOpen,
      toggleSidebar,
    }),
    [isOpen, toggleSidebar],
  );

  return (
    <SmallScreenNavigationSideMenuContext.Provider value={value}>{props.children}</SmallScreenNavigationSideMenuContext.Provider>
  );
};

export const useSmallScreenNavigationSideMenu = () => React.useContext(SmallScreenNavigationSideMenuContext);
